import TenderImages from '@/assets/tenderImages'
import store from '@/store/store'

export default {
  toNumberFormat(value, currency) {
    const langMapping = {
      en: 'en-US',
      ua: 'uk-UA',
    }

    const curLang = langMapping[store.state.i18n.locale]

    return new Intl.NumberFormat(curLang || 'uk-UA', {
      style: 'currency',
      currency: currency,
    }).format(value)
  },
  toDateFormat(value) {
    if (store.state.i18n.locale === 'en') {
      return new Intl.DateTimeFormat('en-US').format(value)
    } else {
      return new Intl.DateTimeFormat('uk-UA').format(value)
    }
  },
  substring(text, length) {
    if (text && length) {
      if (text.length >= length) {
        let substringText = text.substring(0, length)
        substringText += ' ...'
        return substringText
      } else {
        return text
      }
    }
  },
  // findCpvImage (cpv) {
  //     return new Promise((resolve, reject) => {
  //         resolve(
  //             Object.keys(TenderImages).forEach(item => {
  //                 if (cpv.substring(0, 2) === item.substring(0, 2)) {
  //                     console.log('Global fnc', TenderImages[item].url)
  //                     return TenderImages[item].url
  //                 }
  //             })
  //         );
  //     })
  // }
  findCpvImage(cpv) {
    let value
    Object.keys(TenderImages).forEach((item) => {
      if (cpv.substring(0, 2) === item.substring(0, 2)) {
        value = TenderImages[item].src
        return true
      }
    })
    return value
  },
  toKebabCase(str) {
    if (!str) return str
    return str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
      return str.toUpperCase()
    })
  },
}
